module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKWyV9hlIqOjjg.8dacbbf1.woff2";